module.exports = __webpack_public_path__ + "static/assets/15c349fdaf714006a7216a04912d9b0c.png";